// src/hooks/useEvents.js
import { useEffect, useState } from 'react';
import { getEvents } from '../api/events';

export default function useEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch events & convert backend data → FullCalendar format
  const refreshEvents = async () => {
    setLoading(true);
    try {
      const data = await getEvents();

      // Map backend structure → FullCalendar event objects
      const mapped = data.map((e, idx) => ({
        id: String(idx),
        title: e.title || `${e.vrm} – ${e.type}`,
        start: e.start,
        end: e.end,
        allDay: e.allDay ?? false,
        extendedProps: {
          type: e.type,
          vrm: e.vrm,
        },
      }));

      setEvents(mapped);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshEvents();
  }, []);

  return { events, loading, refreshEvents };
}
